import React, { useEffect } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { useLocation } from 'react-router-dom';
interface LayoutProps {
  children: React.ReactNode;
}
const pageTitles: Record<string, string> = {
  '/': 'helgig',
  '/about': 'helgig - About',
  '/writing': 'helgig - Writing',
  '/writing/on-feedback': 'helgig - On Feedback',
  '/writing/on-conflict': 'helgig - On Conflict',
  '/writing/lessons-of-leadership': 'helgig - Lessons of Leadership',
  '/writing/lessons-of-agility': 'helgig - The Lessons of Agility',
  '/writing/lessons-of-strategy': 'helgig - The Lessons of Strategy',
  '/writing/on-teams': 'helgig - On Teams',
  '/services': 'helgig - Services',
  '/services/coaching': 'helgig - Coaching',
  '/services/embedded-partner': 'helgig - Embedded Partner',
  '/services/new-to-leadership': 'helgig - New to Leadership',
  '/services/conflict-and-conversations': 'helgig - Conflict and Conversations',
  '/services/meetings-and-facilitation': 'helgig - Meetings and Facilitation',
  '/services/leading-in-complexity': 'helgig - Leading in Complexity',
  '/services/courses': 'helgig - Courses',
  '/services/courses/conflict-coaching': 'helgig - Conflict Coaching',
  '/services/courses/first-time-manager': 'helgig - First-Time Manager',
  '/services/courses/better-online-meetings': 'helgig - Better Online Meetings',
  '/services/courses/better-online-workshops': 'helgig - Better Online Workshops',
  '/services/courses/modern-product-management': 'helgig - Modern Product Management',
  '/services/courses/art-of-facilitation': 'helgig - The Art of Facilitation',
  '/services/workshops': 'helgig - Workshops',
  '/services/workshops/strategy': 'helgig - Strategy Workshop',
  '/services/workshops/feedback-culture': 'helgig - Feedback Culture Workshop',
  '/services/workshops/coaching-skills': 'helgig - Coaching Skills for Managers',
  '/services/talks': 'helgig - Talks',
  '/events': 'helgig - Events',
  '/contact': 'helgig - Contact',
  '/privacy': 'helgig - Privacy',
  '/terms': 'helgig - Terms'
};
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  useEffect(() => {
    const title = pageTitles[pathname] ?? 'helgig';
    document.title = title;
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-white overflow-x-hidden" data-id="element-117">
      <Navbar data-id="element-118" />
      <main className="flex-grow" data-id="element-119">{children}</main>
      <Footer data-id="element-120" />
    </div>;
}